import * as DialogPrimitive from "@radix-ui/react-dialog";
import { ImageLightboxPage } from "@/pages/library/ImageLightboxPage";
import { cn } from "@/lib/utils";

/**
 * Modal wrapper for ImageLightboxPage
 * Used when navigating to an image from Library or Chat with backgroundLocation state
 * Renders the lightbox as a full-screen modal overlay, allowing the background to stay mounted
 */
export const ImageLightboxModal = ({ imageData, allImages, onClose }) => {
  return (
    <DialogPrimitive.Root open={true} onOpenChange={(open) => !open && onClose()}>
      <DialogPrimitive.Portal>
        {/* Overlay - slightly transparent to hint at background */}
        <DialogPrimitive.Overlay
          className={cn(
            "fixed inset-0 z-[9998] bg-black/95",
            "data-[state=open]:animate-in data-[state=closed]:animate-out",
            "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
            "duration-150"
          )}
        />
        {/* Content - full screen */}
        <DialogPrimitive.Content
          className={cn(
            "fixed inset-0 z-[9999]",
            "data-[state=open]:animate-in data-[state=closed]:animate-out",
            "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
            "duration-150",
            "outline-none focus:outline-none"
          )}
          onEscapeKeyDown={(e) => {
            e.preventDefault();
            onClose();
          }}
          // Prevent pointer down outside from closing (we handle close manually)
          onPointerDownOutside={(e) => e.preventDefault()}
          onInteractOutside={(e) => e.preventDefault()}
        >
          {/* Visually hidden title for accessibility */}
          <DialogPrimitive.Title className="sr-only">
            Image Viewer
          </DialogPrimitive.Title>
          <DialogPrimitive.Description className="sr-only">
            Full screen image viewer with zoom, navigation, and editing controls
          </DialogPrimitive.Description>

          {/* Render the lightbox page in modal mode */}
          <ImageLightboxPage
            isModal={true}
            onClose={onClose}
            initialImageData={imageData}
            initialAllImages={allImages}
          />
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};

ImageLightboxModal.displayName = "ImageLightboxModal";

export default ImageLightboxModal;
